import React, { createContext, useContext, useState } from 'react';
import { useAuth } from './AuthContext';

const AdminEditContext = createContext({ editMode: false, setEditMode: () => {}, isAdmin: false });

export const AdminEditProvider = ({ children }) => {
  const { user } = useAuth();
  const [editMode, setEditMode] = useState(false);
  const isAdmin = !!user && user.role === 'admin';
  // Si l'utilisateur n'est pas admin, le mode édition est toujours off
  const value = { editMode: isAdmin && editMode, setEditMode, isAdmin };
  return <AdminEditContext.Provider value={value}>{children}</AdminEditContext.Provider>;
};

export const useAdminEdit = () => useContext(AdminEditContext);
